<app-dialog-header headerIcon="sensors" headerText="{{datapoint.SensorName}} Datapoint Last Values"
	(onCloseClick)="onCloseClick()">
</app-dialog-header>

<div class="form-div">

	<!-- Metadata section -->
	<mat-card class="metadata-card">
		<mat-card-content>
			<div class="metadata-grid">
				<div class="metadata-label">PV Name:</div>
				<div class="metadata-value">{{datapoint.PVName}}</div>

				<div class="metadata-label">Datapoint ID:</div>
				<div class="metadata-value">{{datapoint.DataPointID}}</div>

				<div class="metadata-label">Sensor ID:</div>
				<div class="metadata-value">{{datapoint.SensorID}}</div>

				<div class="metadata-label">Webhook ID:</div>
				<div class="metadata-value">{{datapoint.WebhookID}}</div>
				
			</div>
		</mat-card-content>
	</mat-card>

	<!-- Duration selector & navigation -->
	<div class="duration-row">
		<mat-icon matTooltip="Navigate Backwards" (click)="navigateByDuration(false)">
			chevron_left
		</mat-icon>

		<app-duration-selector [(duration)]="strDuration" (durationChange)="selectTime($event)"
			[chipDurations]="chipDurations">
		</app-duration-selector>

		<mat-icon matTooltip="Navigate Forwards" (click)="navigateByDuration(true)">
			chevron_right
		</mat-icon>

		<span *ngIf="visibleStartDate && visibleEndDate" class="date-range">
			({{getShortDate(visibleStartDate)}} - {{getShortDate(visibleEndDate)}})
		</span>
	</div>

	<!-- Chart -->
	<ejs-chart #myChart id="myChart" [height]="chartHeight" [width]="chartWidth" [primaryXAxis]='sensorXAxis'
		(tooltipRender)="onTooltipRender($event)" [tooltip]='tooltipSettings'>
	</ejs-chart>

	<!-- Metadata section -->
	<mat-card class="metadata-card">
		<mat-card-content>
			<div class="metadata-grid">

				<div class="metadata-label">Min:</div>
				<div class="metadata-value">{{dpMin}}</div>

				<div class="metadata-label">Datapoint Count:</div>
				<div class="metadata-value" *ngIf="parsedData">{{parsedData.length || 0}}</div>

				<div class="metadata-label">Max:</div>
				<div class="metadata-value">{{dpMax}}</div>
				
				<!-- <div class="metadata-label">Last Datapoint Recieved:</div>
				<div class="metadata-value" *ngIf="parsedData">{{convertEpoch(datapoint.LastValueReceived)}}</div> -->

				<div class="metadata-label" [ngStyle]="{'color': intervalObject ? 'darkgreen' : 'darkred'}" >Chart Last Updated:</div>
				<div class="metadata-value" [ngStyle]="{'color': intervalObject ? 'darkgreen' : 'darkred'}" >{{lastUpdatedTime}}</div>
			</div>
		</mat-card-content>
	</mat-card>

	<!-- Dialog actions -->
	<div mat-dialog-actions class="action-buttons">
		<button mat-button (click)="onCloseClick()">Ok</button>
		<button mat-button (click)="onCloseClick()" cdkFocusInitial>Cancel</button>
	</div>

	<!-- Spinner -->
	<div class="local-spinner" *ngIf="spinner">
		<img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/loading.gif"
			[attr.x-contenttype]="'image/gif'" alt="Loading..." />
	</div>

</div>